import Strings from "@my-dld/assets/strings";
import EjariWebConfig from "../EjariWebConfig";
import React from "react";
import { EjariProperty, EjariPropertyType } from "@eres/ejari-api/Entity";
import { LocaleUtil } from "@eres/core";

export function EjariHeader( props: { property?: EjariProperty } ) {
	const { property } = props;
	if ( property == null ) return <React.Fragment/>;
	let { val, lbl, icon } = extractPropInfo( property );
	return <div className="property-info-summary">
		<div>
			<div className="property-icon">
				<img src={ EjariWebConfig.rootUrl + "assets/property-icons/" + icon + ".svg" }/>
			</div>
		</div>
		<div className="seperator-v"/>
		<div>
			<span>{ val }</span>
			<span>{ lbl }</span>
		</div>
		<div className="seperator-v"/>
		<div>
			<span>{ property.IsFreeHold ? Strings.yes : Strings.no }</span>
			<span>{ Strings.freehold }</span>
		</div>
		<div className="seperator-v"/>
		<div>
			<span>{ property.IsRented ? Strings.yes : Strings.no }</span>
			<span>{ Strings.rented }</span>
		</div>
	</div>;
}

export function extractPropInfo( property: EjariProperty ) {
	let icon = "unit";
	let val = "";
	let lbl = "";
	switch ( property.PropertyType ) {
		case EjariPropertyType.LAND:
			val = property.LandNumber;
			lbl = Strings.land_num_label;
			icon = "land";
			break;
		case EjariPropertyType.UNIT:
			val = property.UnitNo;
			lbl = Strings.Unit_Number_Label;
			icon = "unit";
			break;
		case EjariPropertyType.VILLA:
			val = LocaleUtil.getLocalValue( property.BuildingName );
			lbl = Strings.villa_name;
			icon = "villa";
			break;
		case EjariPropertyType.BUILDING:
			val = LocaleUtil.getLocalValue( property.BuildingName );
			lbl = Strings.building_name;
			icon = "building";
			break;
	}
	return { val, lbl, icon };
}
